import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { default as MaterialSnackbarContent } from '@material-ui/core/SnackbarContent';
import Button from './Button';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';

var styles = function styles(theme) {
  return {
    snackbar: {
      boxShadow: 'none'
    },
    squaredSnackbar: {
      boxShadow: 'none',
      borderRadius: 0,
      padding: '8px 32px',
      maxWidth: '1000px'
    },
    compact: {
      minWidth: '0px'
    },
    info: {
      border: '1px solid #57637C',
      backgroundColor: '#FBFCFD',
      color: '#333940'
    },
    message: {
      width: 'calc(100% - 230px)'
    },
    root: {
      maxWidth: '100%'
    }
  };
};

var SnackbarContent =
/*#__PURE__*/
function (_Component) {
  _inherits(SnackbarContent, _Component);

  function SnackbarContent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SnackbarContent);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SnackbarContent)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.onClose = function () {
      var onClose = _this.props.onClose;
      if (onClose) onClose();
    }, _temp));
  }

  _createClass(SnackbarContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          timeout = _this$props.timeout,
          onClose = _this$props.onClose;
      onClose && timeout && setTimeout(function () {
        return onClose();
      }, timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          message = _this$props2.message,
          messageComponent = _this$props2.messageComponent,
          moreInfoText = _this$props2.moreInfoText,
          moreInfoAction = _this$props2.moreInfoAction,
          acceptText = _this$props2.acceptText,
          acceptAction = _this$props2.acceptAction;
      return React.createElement(Grid, {
        container: true,
        justify: 'center',
        style: {
          position: 'fixed',
          bottom: '15px',
          zIndex: 20000
        }
      }, React.createElement(Grid, {
        item: true,
        md: 8,
        sm: 10,
        xs: 12,
        className: classNames(classes.squaredSnackbar, classes.info, classes.compact)
      }, React.createElement(Grid, {
        container: true,
        alignItems: 'center'
      }, React.createElement(Grid, {
        item: true,
        lg: 9,
        md: 8,
        sm: 12
      }, message && React.createElement(Typography, null, message), messageComponent), React.createElement(Grid, {
        item: true,
        lg: 3,
        md: 4,
        sm: 12
      }, React.createElement(Grid, {
        container: true,
        justify: 'center',
        spacing: 16
      }, React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        onClick: moreInfoAction,
        color: 'secondary',
        variant: 'text'
      }, moreInfoText ? moreInfoText : 'More info')), React.createElement(Grid, {
        item: true
      }, React.createElement(Button, {
        onClick: acceptAction
      }, acceptText ? acceptText : 'I Accept')))))));
    }
  }]);

  return SnackbarContent;
}(Component);

SnackbarContent.propTypes = _extends({}, MaterialSnackbarContent.propTypes, {
  onClose: PropTypes.func,
  timeout: PropTypes.number
});
export default withStyles(styles)(SnackbarContent);